import { apiClient } from './client';

export type LogSeverity = 'DEFAULT' | 'DEBUG' | 'INFO' | 'NOTICE' | 'WARNING' | 'ERROR' | 'CRITICAL';

export interface LogEntry {
  insert_id: string | null;
  timestamp: string;
  severity: string;
  service: string;
  message: string;
  fields: Record<string, unknown>;
}

export interface LogListResponse {
  entries: LogEntry[];
  next_page_token: string | null;
}

export interface LogStatus {
  available: boolean;
  env: string;
  project_id: string | null;
  credential_source: 'env_key' | 'adc' | null;
  reason: string | null;
}

export interface LogQuery {
  /** 절대 시각(ISO). 다음 페이지도 같은 값이어야 Cloud Logging 이 페이지 토큰을 받는다. */
  since: string;
  service?: string;
  min_severity?: LogSeverity;
  request_id?: string;
  user_id?: string;
  q?: string;
  hide_health?: boolean;
  after?: string;
  page_size?: number;
  page_token?: string;
}

// 빈 칸은 보내지 않는다 — 서버가 빈 문자열을 조건으로 받아 아무것도 안 나온다.
const compact = (query: LogQuery) =>
  Object.fromEntries(Object.entries(query).filter(([, v]) => v !== undefined && v !== ''));

export const logsApi = {
  status: async (): Promise<LogStatus> => {
    const response = await apiClient.get<LogStatus>('/logs/status');
    return response.data;
  },

  list: async (query: LogQuery): Promise<LogListResponse> => {
    const response = await apiClient.get<LogListResponse>('/logs', { params: compact(query) });
    return response.data;
  },
};
